import * as React from "react";
import Card from "@mui/material/Card";
// import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
// import Button from "@mui/material/Button";
// import Typography from "@mui/material/Typography";
import "./MediaCard.css";
import { useSelector } from "react-redux";
import { fetchCurrentState } from "../../../../redux/features/customerViewSlice";
import { Swiper, SwiperSlide, useSwiper } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Pagination, Navigation, Virtual } from "swiper";
import { v4 } from "uuid";
import { useNavigate } from "react-router-dom";
import { ChipTitle, dateDDMM, onlySpaces } from "../../../../util";
import guest from "../../../../assets/images/guest.svg";
// import getCurrencySymbol from 'currency-symbol-map'
// import { bookingStatusWrapper } from '../../../../util'
import { mediaViewModel, stayViewModel } from "../../customerViewDataModel";
import calender_icon from "../../../../assets/images/icons/calender_icon.svg";
// import booking_icon from '../../../../assets/images/icons/booking_icon.svg'
import SwiperButtonNext from "../../../common/swiperNextSlide";
import SwiperButtonPrev from "../../../common/swiperPrevSlide";
import { isEmpty } from "lodash";
import leftArrow from "../../../../assets/images/icons/media-left-arrow.svg";
import rightArrow from "../../../../assets/images/icons/media-right-arrow.svg";
import ChipTag from "../../../common/ChipTag";
import TextTruncate from "react-text-truncate";
import leisureDayBig from "../../../../assets/images/leisure-day-big-grey.svg";
import { useMemo } from "react";
import confirmed_icon from "../../../../assets/images/icons/confirmed_icon.svg";
import { useRef } from "react";
import { useEffect } from "react";
import DaySlides from "./DaySlides";
import { useCallback } from "react";
import { useState } from "react";

const SliderComponent = ({
  mediaObject,
  navigate,
  handleDetailPageOpen,
  sliderRef,
  handleNext,
  stayViewData,
  handlePrev,
  setisMediaMuted,
  detailPageState,
  isMediaMuted,
}) => {
  // keep reference unique for each slide
  const [swiper, setSwiper] = React.useState(null);

  const slideTo = (index) => swiper.slideTo(index);
  return (
    <Swiper
      sx={{ boxShadow: "2px 4px 24px rgba(11, 12, 21, 0.1)" }}
      ref={sliderRef}
      style={{
        "--swiper-pagination-color": "var(--primaryShades20)",
        "--swiper-pagination-bullet-inactive-color": "var(--gray20)",
        "--swiper-pagination-bullet-inactive-opacity": "1",
        "--swiper-pagination-bullet-size": "7px",
        "--swiper-pagination-bullet-width": "7px",
        "--swiper-pagination-bullet-height": "7px",
      }}
      slidesPerView={1}
      spaceBetween={30}
      grabCursor={true}
      // loop={true}
      // navigation={true}
      modules={[Navigation]}
      // onSwiper={setSwiper}
    >
      {mediaObject.map((day, index) => {
        // console.log(day.prevDay)
        return (
          <SwiperSlide key={index}>
            <DaySlides
              key={index}
              day={day}
              stayViewData={stayViewData}
              handleDetailPageOpen={handleDetailPageOpen}
              handleNext={handleNext}
              handlePrev={handlePrev}
              setisMediaMuted={setisMediaMuted}
              isMediaMuted={isMediaMuted}
              detailPageState={detailPageState}
            />
          </SwiperSlide>
        );
      })}
    </Swiper>
  );
};

// Main Component-->> MediaCard
function MediaCard(props) {
  console.log(">>>>>:: Media Parent Rendered");

  // let introMuteState = localStorage.getItem('introMuteState')
  // console.log('introMuteState::', introMuteState)
  const [isMediaMuted, setisMediaMuted] = useState(true);

  ////--------------
  const sliderRef = useRef(null);

  const handlePrev = useCallback(() => {
    if (!sliderRef.current) return;
    sliderRef.current.swiper.slidePrev();
  }, []);

  const handleNext = useCallback(() => {
    if (!sliderRef.current) return;
    sliderRef.current.swiper.slideNext();
  }, []);
  ////------------------

  useEffect(() => {
    return () => {
      console.log("Media >>> :: Unmounted");
    };
  }, []);

  const tripStateData = props.tripStateData;

  // const tripStateData = props.tripStateData
  const navigate = useNavigate();
  // const swiper = useSwiper()
  const tripDays = tripStateData.trip_days;
  const mediaObject = mediaViewModel(tripDays);
  const stayViewData = stayViewModel(tripDays);
  console.log(mediaObject);
  console.log(">>>>detailPageState", props.detailPageState);

  return (
    <div>
      <SliderComponent
        mediaObject={mediaObject}
        stayViewData={stayViewData}
        navigate={navigate}
        handleDetailPageOpen={props.handleDetailPageOpen}
        sliderRef={sliderRef}
        handleNext={handleNext}
        handlePrev={handlePrev}
        setisMediaMuted={setisMediaMuted}
        isMediaMuted={isMediaMuted}
        detailPageState={props.detailPageState}
      />
      {/* <div style={{ height: 'calc(100vh - 740px)', flexGrow: '1' }}></div> */}
    </div>
  );
}

export default MediaCard;
export const MemoizedMediaCard = React.memo(MediaCard);
